export default {
  cName: "Tenant Platform",
  last24hours: "Last 24 Hours",
  last7days: "Last 7 Days",
  last30days: "Last 30 Days",
  custom: "Custom",
  multiple: "Multiselect",
  exportEdit: "Export",
  getCode: "Get Verification Code",
  enterPhoneFormat: "Please enter the correct phone number",
  sentSuccessfully: "Sent Successfully",
  resend: "Resend",
  setPower: "Set Power",
  powerPl: "Please Enter Power",
  successfullySet: "Set Successfully",
  rechargeSuccess: "Recharged Successfully",
  sysTitle: "Tenant Platform",
  operatorId: "Operator Code",
  oprName: "Operator Name",
  tips: "Tips",
  isDelete: "Are you sure you want to delete?",
  deleteSuccess: "Deleted Successfully",
  updateSuccess: "Updated Successfully",
  addSuccess: "Added Successfully",
  all: "All",
  operation: "Operation",
  dl: "Electricity Charged (kwh)",
  eleFee: "Electricity Fee",
  serverFee: "Service Fee",
  delayFee: "Overtime Charge",
  totalAmount: "Total Amount",
  yuan: "Idr",
  kWh: "Kwh",
  unitOrder: "Unit",
  ac: "AC",
  dc: "DC",
  confirm: "Confirm",
  noData: "No Data",
  allCity: "All Cities",
  chargingStation: "Charging Station",
  merchant: "Tenant",
  operator: "Operator",
  chargingPile: "Charging Pile",
  year: "Year",
  month: "Month",
  day: "Day",
  timeType: "Type",
  regularText: "Normal",
  irregular: "Abnormal",
  operationSucess: "Success",
  saveSucess: "Saved Successfully",
  exportSuccess: "Imported Successfully",
  allSelect: "Select All",
  toExamine: "Review",
  invalid: "Discard",
  accountBalance: "Account Balance",
  today: "Today",
  thisWeek: "This Week",
  thisMouth: "This Month",
  last5Year: "Last 5 Years",
  regular: {
    name: "Name",
    please: "Please Input ",
    max: " no more than ",
    maxText: " Characters",
    min: "Not Less Than",
    numberABC: "It can only consist of numbers or letters",
    number_ABC: "It can only be composed of numbers, letters and underscores",
    tel: "Please enter the mobile number or the phone number, 6-15 digits",
    phone: "Please enter the phone number",
    phonePl: "Please input mobile phone number",
    phonePl11: "Please enter the 11 digit mobile phone number",
    phoneError: "Please input the correct mobile phone number",
    int: "It can only be an integer number",
    maxInput: "Maximum Input",
    minInput: "Minimum Input",
    unit: "",
    maxNum: "Cannot be greater than",
    minNum: "Cannot be less than",
    money: "Amount Of Money",
    towDecimal: "Keep up to two decimal places",
    email: "Please Input Email",
    emailPl: "Mailbox Cannot Exceed",
    emailError: "Please fill in the correct email",
    passwordTips1: "Character limit: 12 to 18 characters",
    passwordTips2:
      "Must include uppercase letters, lowercase letters, numbers, and special characters: '!', '#', '$', '%', '&'."
  },
  unitText: {
    pen: "",
    yuan: "Idr",
    hours: "Hours",
    people: "People",
    seat: "Seat",
    k: "K",
    kYuan: "K Idr",
    kKWh: "K Kwh",
    kKW: "K Kw",
    year: "Year",
    month: "Month",
    day: "Day",
    ton: "Ton",
    second: "Times",
    full: "Exceed",
    reduce: "Reduce",
    give: "Give",
    zhang: "Units",
    individual: "Units"
  },
  formText: {
    startTime: "Start Time",
    endTime: "End Time",
    export: "Export",
    exportLoading: "Exporting...",
    exportNumber: "Exported Entries",
    exportPl: "The number of exported entries must be greater than 0",
    exportError: "Export error or timeout",
    allCity: "All Cities",
    selectGun: "Charger Connector",
    selectMch: "Tenant",
    selectSite: "Station",
    selectPile: "Charger No.",
    selectTime: "Select Time",
    selectTimePl: "Please Select Time",
    selectOper: "Operator",
    downloadForm: "Download Form",
    intTips: "Value",
    beginTimeTips: "Please select start time",
    endTimeTips: "Please select end time",
    import: "Import",
    selectProvince: "Please select a province",
    selectCity: "Please select a city",
    selectArea: "Please select a district",
    subSuccess: "Success",
    goBack: "Go Back",
    timeNull: "Please select a time",
    timeMax: "The start time cannot exceed the end time"
  },
  directCurrent: "DC",
  alternatingCurrent: "AC",
  gunStatus: "Connector Status",
  gunStatusObj: {
    onLine: "Online",
    offLine: "Offline",
    free: "Available",
    connected: "Plugged In",
    charging: "Charging",
    full: "Completed",
    trouble: "Fault",
    disabled: "Disabled",
    booked: "Booked"
  },
  search: "Search",
  update: "Edit",
  add: "Add",
  delete: "Delete",
  close: "Close",
  save: "Save",
  refresh: "Refresh",
  back: "Go Back",
  export: "Export",
  import: "Import",
  submit: "Submit",
  cancel: "Cancel",
  details: "Details",
  safePassword: {
    title: "Please enter the operation password to confirm this action",
    password: "Password",
    noPassword: "Forget The Password?",
    passwordPl: "Please input the password"
  },
  login: {
    contentTitle: "Charging the green future",
    contentTitleSmall:
      "ACcess to the open platform, and walk into the interconnection ecology by one step",
    account: "Account Login",
    userNamePl: "Enter the user name",
    passwordPl: "Please input the password",
    passwordMax: "Please enter password with more than 6 digits",
    userName: "User Name",
    password: "Password",
    login: "Login",
    accountTime: "After",
    accountTime2:
      "Days, the account will expire and you will not be able to log in to the system",
    mchSys: "Tenant Platform",
    changeLangPl: "Please select a language"
  },
  home: {
    todayOrder: "Charging Order",
    todayDl: "Konsumsi Listrik (kwh)",
    todayRevenue: "Revenue Today (idr)",
    gunStatus: "Charger Connector Status",
    mengisiData: "Mengisi Data",
    assetTitle: "Asset",
    siteNum: "Station",
    pileNum: "Charger",
    gunNum: "Connector",
    dcNum: "DC",
    acNum: "AC",
    totalPower: "Total Power (kw)",
    dcPower: "DC Power(kw)",
    acPower: "AC Power(kw)",
    settlementTitle: "Settlement",
    dailyDtatement: "Unsettled Daily Statement",
    withdrawalForm: "Unpaid Withdrawal Orders",
    undrawnAmount: "Amount Being Paid",
    withdrawnAmount: "Amount Paid",
    revenueTitle: "Revenue",
    totalRevenue: "Total Income (idr)",
    onlineChargingSharing: "Online orders' share (idr)",
    offlineChargingSharing: "Offline orders' share (idr)",
    chargingDurationRanking: "Charging Duration Ranking",
    totalChargingDuration: "Total Charging Duration",
    duration: "Duration",
    chargingTimesRanking: "Charging Times Ranking",
    totalChargingTimes: "Total Charging Times",
    times: "Times",
    pile: "Charger",
    utilizationRate: "Utilization Rate",
    order: "Orders (unit)",
    total: "Total",
    hour: ":00"
  },
  nonCard: {
    cardMember: "Charging Card Members",
    cardMemberStatis: "Charging Card Status",
    memberTypeNum: "Member Type",
    member: "Member",
    nonMember: "Non Member",
    use: "In Use",
    logOff: "Deleted",
    recharged: "Recharged (idr)",
    charged: "Paid (idr)",
    globalSearch: "Transaction number / card number",
    cardStatis: "Card Status",
    activation: "Active",
    unactivated: "Inactive",
    disabled: "Disabled",
    expired: "Expired",
    normal: "Normal",
    logOffBtn: "Delete",
    delete: "Delete",
    rechargedBtn: "Recharged",
    refundBtn: "Refund",
    operationRecord: "Operation Record",
    capitalRecord: "Fund Record",
    thisYear: "This Year",
    accountPkId: "Card Serial Number",
    cardPhysicalNumber: "Card Number",
    memberType: "Member Type",
    name: "Name",
    email: "E-mail",
    validity: "Validity",
    cardSerialNumber: "Transaction Number",
    silkScreenNumber: "Silk Screen Number",
    contactName: "Contact Name",
    phoneNo: "Phone",
    accountBalance: "Card Balance (idr)",
    cardStatus: "Status",
    createTime: "Card Opening Time",
    cardPkId: "Card Number",
    remarks: "Notes",
    rechargeAmount: "Recharge Amount",
    selectMemberType: "Select member card type",
    NIK: "Identity Card Number",
    validPeriodSelection: "Valid Period Selection",
    chargingHours: "Charging Hours",
    chargingHoursTip: "Daily charging duration limit",
    saveOnly: "Save Only",
    keepAndActivate: "Keep And Activate",
    verCode: "Verification Code"
  },
  nonFundHistory: {
    rechargedTab: "Recharged",
    chargedTab: "Charged",
    staName: "Station Name",
    chargeBeginTime: "Start Time",
    chargeEndTime: "End Time",
    chargeMinutes: "Charging Time",
    chargeElect: "Electricity Charged (kwh)",
    delayAmount: "Overtime Charge (idr)",
    delayDuration: "Delay Duration",
    chargeAmount: "Charging Amount (idr)",
    beforeBalance: "Previous balance payment (idr)",
    afterBalance: "Subsequent balance payment (idr)",
    orderNo: "Order Number",
    transactionTime: "Recharge Time",
    rechargeAmount: "Amount (idr)",
    createName: "Operator",
    refundTime: "Refund Time",
    refundAmount: "Refund Amount (idr)",
    refundedAmount: "Amount Refunded (idr)",
    refundResultDesc: "Refund Progress",
    time: "Time"
  },
  cancellation: {
    cardSerialNumber: "Transaction Number",
    accountBalance: "Amount",
    tips:
      "Upon cancellation, the amount in the card will be automatically refunded and the charging card will not be available for use.",
    success: "Cancelled Successfully",
    successConfirm: "Are you sure you want to cancel the account?"
  },
  nonCardDetails: {
    cardInfo: "Charging Card Information",
    remark: "Notes",
    accountBalance: "Account Balance (idr)",
    createUserName: "Card Opener",
    createTime: "Card Opening Time",
    statusDesc: "Charging Card Status"
  },
  nonRealNameCardManagement: {
    cardMember: "Charging Card Members",
    cardStatus: "Card Status",
    inUse: "In Use",
    cancelled: "Cancelled",
    operationStatistics: "Operation Statistics",
    selfSupport: "Self-owned",
    generationCamp: "Owned By Tenant",
    fuzzySearch:
      "Transaction number / charging card number / contact name / phone",
    cardAffiliation: "Card Owner",
    commercialTenant: "Tenant",
    cardNumber: "Charging Card Number",
    cardPhysicalNumber: "Charging card serial number",
    cardSerialNumber: "Transaction Number",
    contacts: "Contact Name",
    phone: "Phone",
    cardBalance: "Card Balance (idr)",
    frozenAmount: "Frozen Amount (idr)",
    openTime: "Opening Time",
    remark: "Notes",
    money: "Card Opening Amount",
    openCardTips:
      "Please keep the card issuer connected to the computer and place the card on the card sender",
    openCardError: "The charging card has been used. please use another card.",
    cardPhysicalNumberPl: "Please input the transaction number of the card",
    cardSerialNumberPl: "Please enter the serial number",
    moneyPl: "Please enter the recharge amount",
    moneyMax: "The amount of a single recharge cannot be more than 5000",
    moneyMin: "The amount of a single top-up cannot be less than 0",
    moneyError:
      "The opening amount of the card must be a number with no more than two decimal places",
    openCardSuccess: "Card Opened Successfully",
    balance: "Balance",
    amount: "Amount",
    cancellation: "Cancel",
    cancellationTips:
      "Upon cancellation, the amount in the card will be automatically refunded and the charging card will not be available for use.",
    cancellationSuccess: "Cancelled Successfully",
    accountBalance: "Account Balance (idr)",
    createUserName: "Card Opener",
    createTime: "Opening Time",
    status: "Card Status",
    operationInfo: "Operation Information",
    cardInfo: "Card Information",
    cardDetails: "Non-real name card details",
    remarkPl: "Please Enter Notes",
    createName: "Operator",
    operateTime: "Operation Time",
    operateType: "Operation",
    rechargeAmount: "Recharge Amount (idr)",
    allMoneyMax: "The maximum amount of online card cannot exceed 9999 idr",
    accountPkId: "Membership Card Number",
    refundAmount: "Refund Amount (idr)",
    refundBtn: "Refund",
    refundError: "The refund amount cannot exceed the account balance",
    refundSuccess: "Refunded Successfully",
    silkScreenNumber: "Silk Screen Number",
    getCard: "Read Card",
    input: "Import Directly",
    reset: "Reset",
    cardExist:
      "The card already exists. please cancel or use another card before the opening action",
    openCard: "Activate Card",
    silkScreenNumberPl: "Please enter the silk screen number",
    contactsPl: "Please enter a contact name",
    cardYes: "The card can be operated",
    logout: "Cancel The Card",
    viewNo: "Your browser doesn't support the card issuing system",
    connectError: "Issuer Connection Failed",
    logoutSuccess: "Card Cancelled Successfully",
    cardChange: "The card has been changed. please read the card again.",
    cardWhite: "This card is blank. please open it first",
    statusError1: "Please read the card first",
    statusError2: "No charging card detected. please try again.",
    statusError3: "Customer code cannot be empty",
    statusError4: "Card type cannot be empty",
    statusError5: "Id cannot be empty",
    statusError6: "Card id can only be 16 digits",
    statusError7: "Unable to operate. the card is not in the system. ",
    logoutTitle:
      "This operation will delete all the information in this card. please be careful.",
    connectBtn: "Connect Card Issuer",
    connectBtnLoading: "Connecting Card Issuer……",
    cardBind:
      "The card has been used. please change to an unused card. serial number: ",
    relation: "Associate",
    userName: "Member Name",
    cardNumberPl: "Please enter the card number",
    relationSuccess: "Associated Successfully",
    hasSms: "Send Sms",
    hasSmsPl: "Please select whether to send sms",
    word: "Tips: Instructions",
    wordDownload: "Click here to download",
    no: "No",
    yes: "Yes",
    cardConnectionFailed: "Card issuer connection failed",
    notSupport: "Your browser doesn't support the card issuing system"
  },
  cardTips: {
    t1: "1. download and install the card issuer driver",
    download: "Click here to download",
    t1_1: "For windows xp systems, please",
    t2:
      "2. connect the card reader to the computer through the usb cable. after the power on, the card reader will make a 'beep' sound and keep the led inside the card reader flashing.",
    t3: "3. download and run the card issuer plug-in(",
    t3_1: "), after connecting the card reader, click 'open service'.",
    t4: "4. open the card issuing management of the browser for operations.",
    tips: "Notes: ",
    tips1:
      "1. for now, it supports windows system and windows 7 / 10 series versions.",
    tips1_1:
      "If you want to use it under windows xp, you need to install the. net3.5 framework",
    tips2:
      "2. during the process, ensure that the card issuer plug-in is in service open status.",
    tips3:
      '3. when the prompt "check whether to insert a card reader or install a serial port driver" appears, it is generally showing a problem that the card reader is not inserted or the serial port driver is not installed. right click "my computer" and select "management", and then in the pop-up "computer management" window, click "device manager" in the left menu, check whether "usb serial port" or "ft232rusr uart" exists under "other devices". if not, it means that the card reader is not plugged in. try another usb to do it again.'
  },
  addMerchant: {
    accountInfo: "Account Information",
    info: "Basic Information",
    fullName: "Tenant Name",
    shortName: "Tenant Abbreviation",
    contacts: "Contact Name",
    contactsMail: "Contact Email",
    telephone: "Contact Number",
    address: "Contact Address",
    operatorShare: "Operator Share",
    shareType: "Sharing Type",
    isMoneyRules: "Fixed Amount",
    isMoneyRulesShareMaxError:
      "Fixed amount cannot be greater than the total share amount",
    orderTotalMoney: "Total amount of every order",
    orderTotalMoneyMax: "฿",
    orderShare: "Share of each order",
    isMoneyRulesTips:
      "Display the corresponding share amount according to the sharing type. the sharing type can be multiselected.\r\n\r\nnote: after the fixed amount is selected, the total amount cannot be selected at the same time for each order",
    isPercentageRules: "Percentage",
    order: "Every Order",
    cashConfig: "Withdrawal Settings",
    cashMin: "Minimum Withdrawal Amount",
    condition: "Condition",
    fromValueTips: "Settlement Amount Exceeds",
    feeTips: "Deduct Transfer Fee",
    feeTipsPl: "Deduct transfer fee at percentage ",
    loginUrl: "Login Address",
    addTitle: "Add Account Number",
    resetPassword: "Reset Password",
    mchCollectionInfo: "Tenant Receiving Information",
    bankAccountName: "Bank Account Name",
    bankDeposit: "Receiving account opening bank",
    bankAccountNo: "Receiving Bank Account",
    addMch: "Add Tenant",
    loginTitle: "Add Login Account",
    updataTitle: "Modify Login Account",
    required: "Required",
    textLenMax: "Length Cannot Exceed",
    divisionPercentPl: "Please select the sharing type",
    divisionPercentMax: "Value range: 0.00 ~ 100",
    divisionPercentError: "Please enter a valid number",
    base2: "Percentage",
    minWithdrawAmount: "Minimum Withdrawal Amount",
    bankDepositPl:
      "Please enter the name of the receiving account opening bank",
    bankAccountNamePl: "Please enter the name of the receiving account",
    userName: "Login User Name",
    effectiveTime: "Entry-info-force Time",
    expireTime: "Expiration Time",
    accountName: "Account Name",
    bankInstitutionDesc: "Bank Name",
    remarks: "Notes",
    delConfig: "Are you sure you want to delete the current account?",
    userParamsNull: "Login user account cannot be empty",
    isPercentageRulesPl: "Please select the type of percentage",
    isPercentageRulesError: "The type of percentage cannot be repeated",
    addSuccess: "Added Successfully",
    mchLoginInfo: "Tenant Login Information",
    userParamsMax: "There can only be one login user",
    mchDetails: "Tenant Details",
    upDetails: "Modify Tenant",
    add: "Add",
    rolePkIdPl: "Please select a role",
    expireTimePl: "Please select the effective date first",
    expireTimeError: "Cannot be earlier than the effective date",
    userNameError: "The user name already exists",
    issueCardCode: "Customer Code",
    userPwd: "Password",
    confirmPassword: "Confirm Password",
    amountType: "Electricity fee per order",
    amountType2: "Service fee per order",
    amountType3: "Overtime charge per order",
    cooperationTime: "Cooperation Deadline",
    currentPassword: "Current Password"
  },
  upSafePassword: {
    userPwd: "New Password",
    confirmPassword: "Repeat New Password",
    verCode: "Verification Code",
    verCodePl: "Verification code cannot be empty",
    userPwdPl: "Password cannot be empty",
    userPwdLen: "Password length is 6-18",
    userPwdError: "Passwords cannot contain spaces, tabs, or line breaks",
    confirmPasswordPl: "Confirmation password cannot be empty",
    confirmPasswordError: "The passwords do not match",
    upError: "Modification Failed",
    upSuccess: "Password changed successfully。 please log in again"
  },
  commonTableName: {
    cardNo: "Card Number",
    insideOrderNo: "Order Number",
    externalOrderNo: "External Order",
    orderStatus: "Order Status",
    orderType: "Order Type",
    no: "No",
    yes: "Yes",
    details: "Details",
    endOrder: "Close Order",
    error: "Exception Handling",
    orderNo: "Order Number",
    merchantName: "Tenant Name",
    netSystemName: "Partner Operators",
    orderStatusDesc: "Order Status",
    staName: "Station",
    pileName: "Charger Name",
    gunName: "Connector Name",
    serialNumber: "Charger No.",
    memberName: "Member Name",
    phoneNo: "Phone",
    carNo: "License Plate",
    chargeBeginTime: "Start Charging Time",
    chargeEndTime: "End Charging Time",
    payTime: "Payment Time",
    chargeDuration: "Charging Duration",
    delayDuration: "Delay Time",
    chargeElect: "Electricity(kwh)",
    chargeAmount: "Electricity Fee (idr)",
    serviceAmount: "Service Fee (idr)",
    time: "Time",
    delayAmount: "Overtime Charge (idr)",
    totalAmount: "Total Amount (idr)",
    discountAmount: "Discount Amount (idr)",
    transactionAmount: "Paid Amount (idr)",
    startSoc: "Start Soc",
    endSoc: "End Soc",
    stopReason: "Stop Reason",
    orderSource: "Order Source",
    abnormalType: "Abnormal",
    elecPrice: "Electricity Rate (idr/kwh)",
    servicePrice: "Servic Rate (idr/kwh)",
    slotFlag: "Electricity Fee Type",
    slotElecPrice: "Electricity Price (idr)",
    delayMins: "Duration (minute)",
    delayFreeMins: "Free time range (minute)",
    sex: "Gender",
    vipType: "Member Type",
    vin: "Vin Code",
    cardType: "Car Model",
    staType: "Station Type",
    staStatus: "Station Status",
    staAddr: "Station Address",
    gunPkId: "Connector Number",
    manufacturer: "Belong To Manufacturer",
    deviceType: "Charger Type",
    devicemodel: "Equipment Model",
    ratedPower: "Rated Power",
    ratedCurrent: "Rated Current",
    ratedVoltage: "Rated Voltage",
    timeInterval: "Time Range",
    chargeDiscount: "Electricity Discount",
    serviceDiscount: "Service Fee Discount",
    delayDiscount: "Overtime Charge Discount",
    totalDiscount: "Total Discount Amount",
    chargeTransAmount: "Paid electricity fee (idr)",
    serviceTransAmount: "Paid service fee (idr)",
    jian: "Sharp",
    feng: "Peak",
    ping: "Flat",
    gu: "Valley",
    beforeBalance: "Previous balance payment (idr)",
    afterBalance: "Subsequent balance payment (idr)",
    reteInfo: "Rate Information",
    charge: "Charging Times",
    startTime: "Start Time",
    endTime: "End Time",
    modifyTime: "Update Time",
    staPkId: "Station Id",
    entUserName: "Enterprise Name",
    chargingCard: "User Card Number",
    chargingMode: "Charging Mode",
    userType: "User Type",
    stationRegion: "Station Region",
    cardNameOrMemberName: "Card Name/Member Name",
    memberType: "Member Type"
  },
  orderList: {
    orderSource1: "Online Order",
    orderSource2: "Offline Order",
    exportType: "Default",
    exportType2: "Details",
    end: "Charging Ended",
    endConfirm: "Are you sure you want to close the order?",
    endLoadingTips: "Issue stop charging command",
    endLoadingTips2:
      'The system will issue the stop charging command to the charger. if the order status cannot be changed to "charging completed" within 15s, the second step will be triggered',
    endLoadingTips3: "Generate platform charging report",
    endLoadingTips4:
      'The system will send the platform charging report to the charger. if the order status cannot be changed to "charging completed" within 15s, the third step will be triggered',
    endLoadingTips5: "Modify order status to abnormal",
    endLoadingTips6:
      "The system will modify this order as abnormal, and the user can perform the next charging action normally",
    endLoading: "Processing..",
    endCharge: "End Charging",
    loadingSuccess: "The stop command is issued successfully",
    success: "Platform report generated successfully",
    orderError: "Order status changed to abnormal",
    endSuccess: "Ended Successfully",
    pageTitle: "Charging Order",
    totalChargeElect: "Total electricity charged (kwh)",
    totalTransactionAmount: "Total actual revenue (idr)",
    totalServiceAmount: "Service Fee (idr)",
    totalChargeAmount: "Electricity Fee (idr)",
    totalDelayAmount: "Overtime Charge (idr)",
    totalDiscount: "Total Discount (idr)",
    totalServiceDiscount: "Service fee discount (idr)",
    totalChargeDiscount: "Electricity fee discount (idr)"
  },
  abnormalOrder: {
    pileCharging: "Charger Billing (idr)",
    chargeTime: "Charging Duration",
    stopReason: "Stop Reason",
    pileChargeAmount: "Total charger billing (idr)",
    sysCharging: "Platform Billing (idr)",
    sysChargeAmount: "Total platform billing (idr)",
    pileErrorValue: "Gap value with charger billing:",
    normalErrorValue:
      "Normal gap: less than 0.5 idr or gap percentage less than 20%",
    usePileCharging: "Use Charger Billing",
    useSysCharging: "Use Platform Billing",
    useInputharging: "Manually Input Amount",
    amountPayable: "Amount Due (idr)",
    countType:
      "Calculation formula: total charger billing / (total platform billing + total overtime charge)",
    payAmount: "Total Payment (idr)"
  },
  orderDetails: {
    aorderDetailsTitle: "Charging Order Details",
    chargeType: "Charging Type",
    chargeStatus: "Charging Status",
    chargingModel: "Charging Strategy",
    chargeElect: "Electricity Charged (kwh)",
    chargeDuration: "Charging Duration",
    orderCheckDetails: "Order Verification Details",
    chargeDataEchart: "Charging Data",
    chargeMoneyEchart: "Charging billing line chart",
    batteryEchart: "Battery data line chart",
    faultCode: "Exception Code",
    faultName: "Exception Name",
    faultDesc: "Exception Description",
    userInfo: "User Info",
    siteInfo: "Station Info",
    siteId: "Station Id",
    pileInfo: "Charger Info",
    rateInfo: "Fee Info",
    errorHandle: "Exception Handling",
    billingMethod: "Billing Method",
    operationTime: "Operation Time",
    operationoOject: "Operation Object",
    insertGun: "Insert A Connector",
    startCharging: "Start Charging",
    endCharging: "End Charging",
    draw: "Unplug",
    outputVoltage: "Output Voltage",
    chargingPower: "Charging Power",
    outputCurrent: "Output Current",
    demandVoltage: "Demand Voltage",
    demandCurrent: "Demand Current",
    cpVoltage: "Cp Voltage",
    chargerTemperature: "Charger Temperature",
    gunTemperature: "Connector Temperature",
    brmProtocol: "Brm Protocol Version",
    brmBatteryType: "Brm Battery Type",
    brmBatteryCapacity: "Brm battery rated capacity",
    brmRatedVoltage: "Brm rated total voltage",
    BCPMaxVoltage: "Maximum voltage of bcp unit",
    BCPMaxCurrent: "Bcp Maximum Current",
    BCPBatteryEnergy: "Total energy of bcp battery",
    BCPMacVoltage: "Bcp maximum charging voltage",
    BCPMaxTemperature: "Bcp Maximum Temperature",
    BCPStartSOC: "Bcp Start Soc",
    BSMMaxTemperature: "Bsm maximum power cell temperature",
    BCSMaxBatteryVoltage: "Bcs maximum single cell voltage"
  },
  offCardOrder: {
    cardPhysicalSn: "Serial Number",
    cardSn: "Physical Card Number",
    chargeMode: "Charging Mode",
    dealType: "Order Status",
    exportName: "Offline Card Order",
    dl: "Electricity Charged (kwh)",
    amount: "Income (idr)",
    service: "Service Fee (idr)",
    chargingTime: "Charging Duration",
    orderNumber: "Order Amount (unit)",
    offCardNum: "Number of offline cards",
    chargingType: "Charging Mode"
  },
  offCardOrderDetails: {
    pageTitle: "Charging Order Details"
  },
  operationData: {
    activeNum: "Active Users",
    orderCount: "Order Amount (unit)",
    chargeHours: "Charging Duration (h)",
    totalElec: "Electricity Charged (kwh)",
    serviceAmount: "Service Fee (idr)",
    todayData: "Data Today",
    todayTotalAmount: "Income Today",
    todayOrderCount: "Orders Today",
    todayTotalElec: "Electricity Charged Today",
    todayActiveNum: "Active Users Today",
    todayDuration: "Duration Today",
    assets: "Asset",
    noStaPkId: "Please select a station",
    modalTab: "Chart",
    modalTab2: "Table",
    fullName: "Member Name",
    phoneNo: "Phone",
    createTime: "Registration Time",
    balanceAmount: "Account Balance (idr)",
    chargeTimes: "​Charging Orders(times)",
    staDataChartTitle: "Charging Station Statistics",
    yAxisName: "Kwh / Idr",
    staDataDl: "Total Electricity",
    staDataAmount: "Total Amount",
    pileChartTitle: "Charger",
    pileChartAc: "AC Charger",
    pileChartDc: "DC Charger",
    pileTitle: "Asset Data"
  },
  alarmEvent: {
    alarmTime: "Alarm Time",
    eventAmount: "Total Events",
    todayEvent: "Today's Events",
    alarmRatio: "Alarm Ratio",
    alarmLevel: "Alarm Level",
    alarmType: "Alarm Type",
    alarmLevelProporsional: "Alarm  level - Proportion",
    alarmTypeProporsional: "Alarm type - Proportion",
    equipmentAlarmAmountTop5: "TOP5 Device Fault Alarms",
    stationAlarmAmountTop5: "Top5 Station Alarms",
    equipmentSn: "Device SN",
    stationName: "Station",
    quantity: "Session",
    faultDesc: "Event Description",
    recoverTime: "Recovery Time",
    duration: "Abnormal Time",
    alarmStatus: "Current Status",
    equipmentType: "Device Type"
  },
  siteMonitor: {
    province: "Province",
    city: "City",
    type: "Type",
    power: "Power",
    equipmentAmount: "Equipment Amount",
    gun: "Connector",
    number: "Number",
    voltage: "Voltage",
    current: "Current",
    chargeElect: "Electricity",
    totalPower: "Cumulative Charge",
    thisPower: "Current Output Power",
    setPower: "Set Output Power",
    totalTimes: "Cumulative Charging Times",
    totalHours: "Cumulative Charging Duration",
    accountPkId: "Charging Account",
    accountType: "Account Type",
    carVin: "Vehicle Vin",
    chargedMinutes: "Charging Duration",
    chargingPower: "Electricity Charged (kwh)",
    predictAmount: "Charge Amount (idr)",
    faultInfo: "Malfunction Information",
    orderDetails: "Order Details"
  },
  pileInfo: {
    operationType: "Operation Type",
    staStatus: "Operation Status",
    pileList: "Charger List"
  },
  pileInfoDetail: {
    city: "City",
    staAddress: "Address",
    position: "Construction Station",
    staLat: "Longitude And Latitude",
    staTypeName: "Station Type",
    fullName: "Associated Tenants",
    tagInfoVos: "Station Tags",
    commissioningDate: "Commissioning Time",
    businessBeginHours: "Opening Time",
    parkNum: "Number of parking spaces",
    serviceTel: "Service Phone Number",
    phoneNo: "Station Phone Number",
    hasFreePark: "Whether free parking fee",
    yes: "Yes",
    no: "No",
    remarks: "Tips",
    feeName: "Station Rate",
    DC: "DC Charger",
    AC: "AC Charger",
    oprDelayFeeInfos: "Overtime Charge",
    delayFreeMinutes: "Free Duration",
    staPics: "Station Image",
    staInfo: "Charger Information",
    totalDev: "Total Equipment",
    dcGunCount: "DC Charger Muzzle",
    acGunCount: "AC Charger Muzzle",
    tab1: "Station Details",
    tab2: "Maintenance Records",
    tab3: "Rate Updates",
    price: "Total Price (idr/kwh)",
    manufacturerName: "Equipment Manufacturer",
    ratedPower: "Rated Power (kw)",
    delayUnit: "Idr / Minute",
    reason: "Reason",
    debuggingPeople: "Debugging Personnel",
    debuggingContent: "Debugging Content",
    oldFeeName: "Old Rate",
    newFeeName: "New Rate",
    replaceTime: "Change Date"
  },
  pileInfoEle: {
    addRateBtn: "Add Rate Template",
    upRateBtn: "Change Rate Template",
    delRateBtn: "Delete Rate Template",
    rateTpl: "Rate Template",
    feeName: "Template Name",
    feeNamePl: "Please enter a template name",
    acRate: "AC Charger Rate",
    dcRate: "DC Charger Rate",
    delayRate: "Delay Rate",
    delayFreeMinutes: "Free Duration (min)",
    rate: "Rate",
    elePriceList: "Electricity Price List",
    slotFlag: "Electricity Price Type",
    slotElecPrice: "Electricity Price (idr/kwh)",
    slotServicePrice: "Service Fee (idr/kwh)",
    time: "Time Slot",
    slotDelayPrice: "Rate (idr/min)",
    delRateConfirm: "Are you sure to delete the current electricity price?",
    ratePl: "Please select a rate"
  },
  pileList: {
    batchStaBtn: "Batch associate / unbind",
    batchLineBtn: "Batch online / offline",
    addBtn: "Add Charger Info",
    deviceStatus: "Charger Status",
    showQcode: "Qr Code",
    editGun: "Edit Connector",
    showUnlock: "Unlock",
    offLine: "Offline",
    showFee: "Issue Electricity Price",
    outPile: "Remove Charger",
    unbind: "Unbind",
    downQCode: "Issue",
    staName: "Station",
    internalNumber: "Serial Number",
    chargeGunInfoVoList: "Connector Model",
    parkNo: "Parking Number",
    gunStatus: "Connector Status",
    editPile: "Edit Charger",
    issueSuccess: "Qr code issued successfully",
    showFeeConfirm: "Are you sure to issue the electricity price?",
    showFeeSuccess: "Electricity price issued successfully",
    showUnlockConfirm: "Are you sure to unlock?",
    showUnlockSuccess: "Unlocked Successfully",
    unbindSuccess: "Station Unbound Successfully",
    moveInSta: "Destination Station",
    moveInStaPl: "Please select a station",
    remarks: "Notes"
  },
  addPile: {
    deviceType: "Equipment Type",
    deviceModelPkId: "Equipment Model",
    protocolPkId: "Agreement",
    remark: "Notes",
    gunInfo: "Muzzle Info",
    info: "Information",
    addName: "Add Charger",
    staNamePl: "Station must be selected",
    deviceTypePl: "Device type must be selected",
    deviceModelPkIdPl: "Equipment model must be selected",
    sn: "Charger Number",
    snPl: "Charger number cannot be empty",
    snPl2: "Charger number must be a number",
    snPl3: "Charger number must be numbers or letters",
    pileNamePl: "Charger name cannot be empty",
    deviceStatusPl: "Operation status cannot be empty",
    protocolPkIdPl: "Please select agreement primary key",
    qrcode: "Qr Code",
    detailsName: "Charger Details",
    updataName: "Eidt Charger",
    charging: "Charging",
    inserted: "Connector Plugged",
    fault: "Malfuction",
    disable: "Disable",
    offLine: "Offline",
    free: "Free",
    full: "Full",
    subscribe: "Book",
    offline: "Offline",
    online: "Online"
  },
  splitSettlement: {
    shareSettlement: "Share Settlement",
    orderBreakdown: "Order Breakdown",
    merchantName: "Tenant Name",
    chargingOrderNumber: "Charging Order Number",
    selectionTime: "Select Time",
    chargingStation: "Station",
    chargeVolume: "Electricity Charged (kwh)",
    electricityBill: "Electricity Fee (idr)",
    serviceCharge: "Service Fee (idr)",
    chargeableAmount: "Amount Due (idr)",
    discountAmount: "Discount Amount (idr)",
    totalAmountActuallyPaid: "Actual payment amount (idr)",
    partitionMethod: "Sharing Mode",
    merchantIncome: "Tenant Income",
    operatorShare: "Operator Share",
    orderDate: "Order Date",
    orderTimeError:
      "Order time cannot be empty. please select the correct time.",
    errorStartTimeEndTime: "The start time cannot be later than the end time",
    contentConfirm: "Are you sure you want to select the current data?",
    successfulOperation: "Success",
    daySettlementOrderNumber: "Daily Statement Number",
    dailyStatementStatus: "Daily Statement Status",
    settlementDate: "Settlement Date",
    numberOfOrders: "Order Amount (unit)",
    actualChargeAmount: "Actual payment amount (idr)",
    merchantIncomeAmount: "Tenant share amount (idr)",
    operatorShareAmount: "Operator share amount (idr)",
    createTime: "Generation Date",
    pleaseSelectTheGenerationDate: "Please select the generation date",
    createTimeError:
      "The start time of the generation date cannot be later than the end time",
    selectMonth: "Please select a monthly settlement month",
    confirmDate: "Are you sure to select the current data?",
    confirmGeneration: "Are you sure to regenerate data?",
    withdrawnDate: "Are you sure you want to withdraw the selected data?",
    selectDate: "Are you sure to perform actions on the selected data?",
    selectDateToOperate: "Please select the data to perform actions",
    deleteTitle: "Reason For Invalidation",
    remarkPl: "Please enter the reason",
    supplement: "Supplement",
    orderNo: "Select daily statement number",
    orderNoPl: "Please select an order",
    staName: "Charging Station",
    settlementStatus: "Accounting Status",
    regenerate: "Regenerate",
    allSettlement: "Batch Accounting",
    settlement: "Accounting",
    errorInfo: "Abnormal Info",
    accountingRecords: "Accounting Records",
    accountingRecordsStatus: "Accounting Status",
    accountingRecordsRepairStatus: "Repair Status",
    accountingRecordsTime: "Settlement Date",
    initialAccounting: "Initial Accounting",
    newAccounting: "Latest Accounting",
    ComparisonResults: "Difference in comparison results",
    voidPl: "Please select the statement to be voided",
    voidSuccess: "Statement Voided Successfully",
    auditOrderPl: "Please select the statement to review",
    auditOrder: "Review Statement",
    auditOrderSuccess: "Statement Reviewed Successfully",
    auditOrderConfirm:
      "Cannot be revoked after review. please proceed with caution"
  },
  withdrawal: {
    dataTitle1: "Amount to be withdrawn (idr)",
    dataTitle2: "Withdrawn amount  (idr)",
    withdrawOrderStatus: "Withdrawal Order Status",
    createTime: "Generation Date",
    reviewDate: "Review Date",
    withdrawOrderTemplate: "Withdrawal Order Template",
    withdrawOrderNumber: "Withdraw Order Number",
    withdrawalAmount: "Withdrawal Amount",
    transferFee: "Service Fee",
    actualWithdrawalAmount: "Actual Withdrawal Amount",
    withdrawalAdd: "Add Withdrawal Order",
    preview: "Preview",
    resubmit: "Resubmit",
    withdraw: "Revoke",
    annex: "Attachment",
    transferAmount: "Actual Withdrawal Amount",
    completeTime: "Withdrawal Completion Date",
    orderStatusDesc: "Withdrawal Order Status",
    withdrawWithdrawal: "Revoke Withdrawal Order",
    withdrawWithdrawalConfirm: "Are you sure to revoke the withdrawal order?",
    withdrawWithdrawalSuccess: "Withdrawal order revoked successfully"
  },
  withdrawalTemplate: {
    orderNo: "Withdrawal Order Number",
    order: "Withdrawal Order",
    payee: "Recipient",
    payer: "Payer",
    remarks: "Remarks",
    remarks1:
      "1. the payment amount is generated by operator's app, which is used by customers to charge in the merchant's charging station.",
    remarks2:
      "2. actual withdrawal amount = withdrawal amount of current period - transfer fee;",
    remarks3: "3. the transfer fee is the offline transfer service fee;",
    cashExplain: "Withdrawal Instructions",
    cashExplain1:
      "1. after the bill is verified as correct, the applicant should send the bill to the payer's company by post or by e-mail after stamping and confirming. the payer will complete the offline public or private transfer within 3-5 working days after receipt.",
    cashExplain2:
      "2. by signing and stamping, you agree to this withdrawal settlement.",
    cashMch: "Withdrawal Tenant (stamped):",
    sign: "Signature of authorized representative:",
    time: "Date:",
    download: "Download Certificate",
    cashInfo: "Withdrawal Information",
    merchantName: "Withdrawal Tenant",
    staNameList: "Charging Station",
    previousBalance: "Subsequent balance prior period withdrawal",
    totalAmount: "Withdrawal amount in current period",
    serviceCharges: "Transfer Service Fee",
    transferAmount: "Actual Withdrawal Amount",
    collectionInfo: "Receipt Information",
    mchContactPerson: "Tenant Contact Name",
    mchPhoneNumber: "Tenant Phone",
    bankAccountName: "Company Name",
    collectionAcc: "Receiving Account",
    bankDeposit: "Opening Bank",
    bankAccountNo: "Receiving Account Number",
    payerInfo: "Payer Information",
    oprName: "Payer Name",
    contacts: "Contact Name",
    telephone: "Contact Number",
    invoiceType: "Invoice Type",
    openInfo: "Invoicing Information",
    companyName: "Company Name",
    taxId: "Tax Identification Number",
    payerBankAccountNo: "Account",
    registerAddress: "Delivery Address",
    no: "No Data"
  },
  withdrawFormAdd: {
    pageAdd: "Add Withdrawal Order",
    pageUpdata: "Resubmit Withdrawal Order",
    invoiceType: "Invoicing Or Not",
    totalAmount: "Withdrawal Amount",
    availableAmount: "Withdrawable Amount",
    allWithdraw: "Withdraw All",
    minWithdraw: "Minimum Withdrawal Amount",
    serviceCharges: "Transfer Service Fee",
    transferAmount: "Actual Withdrawal Amount",
    collectionInfo: "Receipt Information",
    bankAccountName: "Account Name",
    bankDeposit: "Opening Bank",
    bankAccountNo: "Bank Account Number",
    amountNullPl: "Please enter the withdrawal amount",
    amountErrorPl:
      "The withdrawal amount must be greater than 0 and no more than two decimal places",
    amountMin: "A single withdrawal amount cannot be less than",
    amountMax: "The withdrawal amount should not exceed the withdrawable amount"
  },
  header: {
    out: "Logout",
    outConfirm: "Are you sure you want to log out?",
    order: "Pending Exception Orders",
    goClick: "Click To Jump",
    unit: "Entries",
    outTime: "Login expired. please login again."
  },
  cashTopUp: {
    cashTopUp: "Cash Top-up",
    topUp: "Top Up",
    orderNo: "Top-up Number",
    userName: "User Name",
    phone: "Phone",
    email: "Email",
    transactionTime: "Top-up Time",
    userEmail: "User Email",
    userPhone: "User Phone",
    amount: "Amount",
    amountTip: "Please enter top-up amount",
    topUpConfirmation: "Cash Top-up Confirmation",
    topUpAmount: "Top-up Amount",
    topUpAmountUnit: "Top-up Amount (idr)",
    confirmUserTip: "Confirm topping up for this user?",
    accountDoesNotExist: "User account does not exist"
  },
  feedback: "Feedback",
  language: "Language",
  saveFailed: "Save Failed",
  emailBandTips:
    "This email is already linked to a charging card. Each email can only be linked to one charging card.",
  emailNoRegTips:
    "This email address has not been registered yet. Please confirm whether to register it as an app user"
};
